import React from 'react'
import { NavLink } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import { processError } from '../../lib/lib'
import {
    // Heart, 
    Star,
    // ArrowCircleDown,
    ArrowCircleRight,
    // ShoppingCart,
} from "phosphor-react"
import { Col, Card, CardImg, CardBody, CardFooter,
    // Spinner
} from 'reactstrap'
import api from '../../api/api'
import Cookies from 'universal-cookie'
import CatalogCardEmulation from './CatalogCardEmulation'
import CatalogCardPriceWrapper from './CatalogCardPriceWrapper'
import BuyButton from '../UI/BuyButton'
const cookies = new Cookies()

class CatalogCard extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            // eslint-disable-next-line no-undef
            imageUrl: process.env.REACT_APP_IMAGEURL,
            favorite: false,
            addToCartAction: false,
        }
        this.readMore = this.readMore.bind(this)
        // this.addToCart = this.addToCart.bind(this)
        this.link = `/item/${this.props.id}`
        this.imgLimit = 5
    }

    readMore(event) {
        event.preventDefault()
        this.props.props.history.push(`/item/${this.props.id}`)
    }

    activateBtn(button) {
        const circle = button.querySelector('.circle-down-icon')
        const cart = button.querySelector('.shopping-cart-icon')
        const text = button.querySelector('.news-btn-desc')
        button.classList.add('active')
        circle.classList.add('d-none')
        cart.classList.remove('d-none')
        text.innerHTML = this.props.t('catalog-order')
    }

    // async catalogAddToStudy(catalogId) {
    //     const token = cookies.get('accessToken')
    //     api.catalogAddToStudy({ token, catalogId })
    //         .then(() => {
    //             this.props.props.history.push('/study')
    //             this.setState({ addToCartAction: false })
    //         })
    //         .catch((e) => processError(e, this.props.props.history))
    // }

    // async catalogGetBuyUrlAndBuy(catalogId) {
    //     const token = cookies.get('accessToken')
    //     api.catalogGetBuyUrl({ token, catalogId })
    //         .then(({ url }) => {
    //             window.open(url, "_blank")
    //             this.setState({ addToCartAction: false })
    //         })
    //         .catch((e) => processError(e, this.props.props.history))
    // }

    // addToCart(event) {
    //     event.preventDefault()
    //     this.setState({ addToCartAction: true })
    //     if (this.props.alreadyHas) {
    //         this.props.props.history.push(`/study`)
    //         return
    //     }
    //     if (!this.props.newPrice) {
    //         this.catalogAddToStudy(this.props.id)
    //         return
    //     }
    //     if (this.props.buyUrl) {
    //         this.catalogGetBuyUrlAndBuy(this.props.id)
    //         return
    //     }
    //     const button = event.target.closest('.btn.catalog-btn.primary.addToCart')
    //     if (button.classList.contains('active')) {
    //         this.props.props.history.push('/cart')
    //     } else {
    //         this.activateBtn(button)
    //         const items = cookies.get('order') || []
    //         items.push({
    //             userId: cookies.get('userId'),
    //             itemId: this.props.id,
    //         })
    //         cookies.set('order', items, { path: '/' })
    //         this.setState({ addToCartAction: false })
    //     }
    // }

    getFavorites({ token, lang, start, end }) {
        api.getFavorites({ token, lang, start, end })
            .then(({ count }) => cookies.set('favorites', count, { path: '/' }))
            .catch((e) => processError(e, this.props.props.history))
    }

    favorite(catalogId) {
        const token = cookies.get('accessToken')
        const lang = this.props.i18n.language
        if (this.state.favorite) {
            api.deleteFavorite({ token, lang, catalogId })
                .then(() => {
                    this.setState({ favorite: false })
                    this.getFavorites({ token, lang, start: 0, end: 1000 })
                })
                .catch((e) => processError(e, this.props.props.history))
        } else {
            api.postFavorite({ token, lang, catalogId })
                .then(() => {
                    this.setState({ favorite: true })
                    this.getFavorites({ token, lang, start: 0, end: 1000 })
                })
                .catch((e) => processError(e, this.props.props.history))
        }
    }

    componentDidMount() {
        const ordered = cookies.get('order') || []
        this.setState({ favorite: this.props.favorite })
        ordered.forEach((item) => {
            if (item.itemId === this.props.id) {
                const card = document.querySelector(`#item-${this.props.id}`)
                const button = card.querySelector('.btn.catalog-btn.primary.addToCart')
                this.activateBtn(button)
            }
        })
    }

    render() {
        const { t } = this.props
        return (
            <Col
                md={this.props.cols === 2 ? 6 : 12}
                lg={this.props.cols === 2 ? 6 : 12}
                xl={this.props.cols === 2 ? 6 : 12}
                className={`catalog-card d-flex align-items-stretch${this.props.access ? '' : ' disabled'}`}
                id={`item-${this.props.id}`}
            >
                {
                    this.props.skeleton ?
                        <CatalogCardEmulation cols={this.props.cols} />
                        :
                        <React.Fragment>
                            {
                                this.props.cols === 2 ?
                                    <Card className="d-flex flex-column border-10">
                                        <div className='card-img-wrapper'>
                                            {
                                                t(`course-type-${this.props.type}`) ? 
                                                    <div className="card-type xs-font-size">{t(`course-type-${this.props.type}`)}</div> : ''
                                            }
                                            <CardImg
                                                src={this.props.image ? `${this.state.imageUrl}/${this.props.image}` : "data:,"}
                                                alt=""
                                                className="card-img-top border-top-10"
                                                onClick={() => this.props.access && this.props.props.history.push(this.link)}
                                            />
                                        </div>

                                        <CardBody className="catalog-body">
                                            <div className="d-flex justify-content-between align-items-start">
                                                <NavLink className="news-title lg-font-size" to={this.props.access ? this.link : '/main'}>
                                                    {this.props.title}
                                                </NavLink>
                                                <Star
                                                    size={28}
                                                    weight={this.state.favorite ? "fill" : "regular"}
                                                    className="favorite-icon"
                                                    style={{ minWidth: '28px' }}
                                                    onClick={() => this.props.access && this.favorite(this.props.id)}
                                                />
                                            </div>
                                            <div className="news-desc md-font-size" dangerouslySetInnerHTML={{
                                                __html: this.props.desc,
                                            }}>
                                            </div>
                                        </CardBody>
                                        <CardFooter className="mt-auto">
                                            <div className="card-tags">
                                                {
                                                    this.props.tags.map((tag, index) => (
                                                        <div
                                                            className={`card-tag xs-font-size ${this.props.activeTags.includes(tag) ? 'active' : ''}`}
                                                            key={`${tag}-${index}`}
                                                            id={`${tag}-${index}`}
                                                            onClick={() => {
                                                                if (this.props.access) {
                                                                    this.props.toggleBtn(tag)
                                                                    this.props.addToFilters('tags', tag)
                                                                }
                                                            }}
                                                        >
                                                            #{tag}
                                                        </div>
                                                    ))
                                                }
                                            </div>
                                            <div className="catalog-white-space"></div>

                                            <div className="catalog-card-bottom">

                                                <CatalogCardPriceWrapper 
                                                    t={t}
                                                    oldPrice={this.props.oldPrice}
                                                    newPrice={this.props.newPrice}
                                                    currency={this.props.currency}
                                                    discount={this.props.discount}
                                                />

                                                <button className="btn catalog-btn read" onClick={(e) => this.props.access && this.readMore(e)}>
                                                    <div className="news-btn-content">
                                                        <ArrowCircleRight size={20} className="icon-primary" />
                                                        <span className="news-btn-desc sm-font-size">{t('catalog-read-more')}</span>
                                                    </div>
                                                </button>
                                                {
                                                    this.props.access ? 
                                                        <BuyButton className="btn catalog-btn primary addToCart" item={{...this.props}} history={this.props.props.history} lang={this.props.i18n.language} />
                                                        // <button
                                                        //     className="btn catalog-btn primary addToCart"
                                                        //     onClick={this.addToCart}
                                                        //     disabled={this.props.ableToSale || this.state.addToCartAction ? false : true}
                                                        // >
                                                        //     {
                                                        //         this.state.addToCartAction ?
                                                        //             <Spinner size="sm" />
                                                        //             :
                                                        //             <div className="news-btn-content">
                                                        //                 <ArrowCircleDown className="circle-down-icon" size={20} color={'#ffffff'} />
                                                        //                 <ShoppingCart className="shopping-cart-icon d-none" size={20} color={'#ffffff'} />
                                                        //                 <span className="news-btn-desc sm-font-size">
                                                        //                     {
                                                        //                         this.props.alreadyHas === true ?
                                                        //                             t('catalog-continue-study') :
                                                        //                             this.props.ableToSale ?
                                                        //                                 this.props.newPrice ?
                                                        //                                     this.props.buyUrl ?
                                                        //                                         t('catalog-buy') :
                                                        //                                         t('catalog-to-cart') :
                                                        //                                     t('catalog-add-to-study') :
                                                        //                                 t('catalog-on-sale-soon')
                                                        //                     }
                                                        //                 </span>
                                                        //             </div>
                                                        //     }
                                                        // </button> 
                                                        : ''
                                                }
                                            </div>
                                        </CardFooter>
                                    </Card>
                                    :
                                    <Card className="d-flex flex-row align-items-center border-10 big-catalog-card">
                                        { 
                                            this.props.image && 
                                                <CardImg
                                                    src={this.props.image ? `${this.state.imageUrl}/${this.props.image}` : "data:,"} alt=""
                                                />
                                        }
                                        <div
                                            className={`card-content ${this.props.image ? '' : 'w-100 px-20'}`}
                                            onClick={() => this.props.access && this.props.props.history.push(this.link)}
                                        >
                                            <CardBody className="catalog-body">
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <NavLink className="news-title lg-font-size" to={this.props.access ? this.link : '/main'}>
                                                        {this.props.title}
                                                    </NavLink>
                                                    <Star
                                                        size={28}
                                                        weight={this.state.favorite ? "fill" : "regular"}
                                                        className="favorite-icon"
                                                        style={{ minWidth: '28px' }}
                                                        onClick={() => this.props.access && this.favorite(this.props.id)}
                                                    />
                                                </div>
                                                <div className="news-desc md-font-size" dangerouslySetInnerHTML={{
                                                    __html: this.props.desc,
                                                }}>
                                                </div>
                                            </CardBody>
                                            <CardFooter className="mt-auto">
                                                <div className="card-tags">
                                                    {
                                                        this.props.tags.map((tag, index) => (
                                                            <div
                                                                className={`card-tag xs-font-size ${this.props.activeTags.includes(tag) ? 'active' : ''}`}
                                                                key={`${tag}-${index}`}
                                                                id={`${tag}-${index}`}
                                                                onClick={() => {
                                                                    if (this.props.access) {
                                                                        this.props.toggleBtn(tag)
                                                                        this.props.addToFilters('tags', tag)
                                                                    }
                                                                }}
                                                            >
                                                                #{tag}
                                                            </div>
                                                        ))
                                                    }
                                                </div>

                                                <div className="catalog-white-space"></div>

                                                <div className="catalog-card-bottom">

                                                    <CatalogCardPriceWrapper 
                                                        t={t}
                                                        oldPrice={this.props.oldPrice}
                                                        newPrice={this.props.newPrice}
                                                        currency={this.props.currency}
                                                        discount={this.props.discount}
                                                    />

                                                    <button className="btn catalog-btn read" onClick={(e) => this.props.access && this.readMore(e)}>
                                                        <div className="news-btn-content">
                                                            <ArrowCircleRight size={20} className="icon-primary" />
                                                            <span className="news-btn-desc sm-font-size">{t('catalog-read-more')}</span>
                                                        </div>
                                                    </button>
                                                    <BuyButton className="btn catalog-btn primary addToCart" item={{...this.props}} history={this.props.props.history} lang={this.props.i18n.language} />
                                                    {/* <button
                                                        className="btn catalog-btn primary addToCart"
                                                        onClick={() => this.props.access && this.addToCart}
                                                        disabled={this.props.ableToSale || this.state.addToCartAction ? false : true}
                                                    >
                                                        {
                                                            this.state.addToCartAction && this.props.access ?
                                                                <Spinner size="sm" />
                                                                :
                                                                <div className="news-btn-content">
                                                                    <ArrowCircleDown className="circle-down-icon" size={20} color={'#ffffff'} />
                                                                    <ShoppingCart className="shopping-cart-icon d-none" size={20} color={'#ffffff'} />
                                                                    <span className="news-btn-desc sm-font-size">
                                                                        {
                                                                            this.props.alreadyHas === true ?
                                                                                t('catalog-continue-study') :
                                                                                this.props.ableToSale ?
                                                                                    this.props.newPrice ?
                                                                                        this.props.buyUrl ?
                                                                                            t('catalog-buy') :
                                                                                            t('catalog-purchase-program') :
                                                                                        t('catalog-add-to-study')
                                                                                    : t('catalog-on-sale-soon')
                                                                        }
                                                                    </span>
                                                                </div>
                                                        }
                                                    </button> */}
                                                </div>
                                            </CardFooter>
                                        </div>
                                    </Card>
                            }
                        </React.Fragment>
                }
            </Col >
        )
    }
}

CatalogCard.propTypes = {
    cols: PropTypes.number,
    i18n: PropTypes.object,
    buyUrl: PropTypes.string,
    t: PropTypes.func,
    id: PropTypes.number,
    props: PropTypes.object,
    discount: PropTypes.object,
    image: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    tags: PropTypes.array,
    partners: PropTypes.array,
    totalPartners: PropTypes.number,
    likes: PropTypes.number,
    oldPrice: PropTypes.number,
    newPrice: PropTypes.number,
    currency: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    type: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    alreadyHas: PropTypes.bool,
    favorite: PropTypes.bool,
    addToFilters: PropTypes.func,
    filters: PropTypes.array,
    toggleBtn: PropTypes.func,
    activeTags: PropTypes.array,
    ableToSale: PropTypes.bool,
    skeleton: PropTypes.bool,
    access: PropTypes.bool,
}

export default withTranslation()(CatalogCard)



// WEBPACK FOOTER //
// ./src/components/Catalog/CatalogCard.jsx